import React, { createContext, useContext, ReactNode } from 'react';

export interface ScrollContextValue {
  scrollY: number;
  containerHeight: number;
  contentHeight: number;
  registerScrollListener: (callback: (scrollY: number) => void) => () => void;
}

const ScrollContext = createContext<ScrollContextValue | null>(null);

export interface ScrollProviderProps {
  children: ReactNode;
  scrollY: number;
  containerHeight: number;
  contentHeight: number;
  registerScrollListener: (callback: (scrollY: number) => void) => () => void;
}

export function ScrollProvider({ 
  children, 
  scrollY, 
  containerHeight, 
  contentHeight, 
  registerScrollListener 
}: ScrollProviderProps) {
  const value: ScrollContextValue = {
    scrollY,
    containerHeight,
    contentHeight,
    registerScrollListener
  };

  return (
    <ScrollContext.Provider value={value}>
      {children}
    </ScrollContext.Provider>
  );
}

export function useScrollContext(): ScrollContextValue | null {
  return useContext(ScrollContext);
}